import PubBaseLayout from "@pub/BaseLayout";
import { Typography } from "@sphtech/dmg-design-system";
import { NoSSR } from "@sphtech/web2-core/components";
import { ResponseType, TRouteWithRedirect } from "@sphtech/web2-core/ssr";
import cx from "classnames";
import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router";

import styles from "./ErrorLayout.module.css";
import ErrorLayoutContainer from "./ErrorLayoutContainer";
import { textForStatusCode } from "./ErrorLayoutTypes";
import ErrorRelatedArticles from "./ErrorRelatedArticles";

const { Heading, Body } = Typography;

const ErrorLayout = ({
  response,
  clientSideError,
}: {
  response: TRouteWithRedirect<unknown, unknown>;
  clientSideError?: boolean;
}): ReactNode => {
  const statusCode = response.statusCode;
  const text = clientSideError
    ? textForStatusCode.clientSideError
    : statusCode === 400 || statusCode === 404 || statusCode === 503
      ? textForStatusCode[statusCode]
      : textForStatusCode[500];
  const navigate = useNavigate();

  useEffect(() => {
    if (response.type === ResponseType.REDIRECT) {
      void navigate(response.target);
      return;
    }
  }, [response, navigate]);

  return (
    <PubBaseLayout ads={false} response={response}>
      {response.type === ResponseType.REDIRECT ? (
        <div
          className={cx(
            styles.bodyContainer,
            styles.gutterHorizontal,
            styles.gutterVertical,
          )}
        >
          <div className={styles.notFoundTopContainer}>
            <Heading.Title>You are being redirected</Heading.Title>
            <Body>
              <a href={response.target}>
                <u>Please click here if your browser does not redirect you.</u>
              </a>
            </Body>
          </div>
        </div>
      ) : (
        <>
          <ErrorLayoutContainer text={text} statusCode={statusCode} />
          {statusCode === 404 && (
            <NoSSR>
              <ErrorRelatedArticles />
            </NoSSR>
          )}
        </>
      )}
    </PubBaseLayout>
  );
};

export default ErrorLayout;
